<template>
    <section class="bg-bdy py-2">
        <div class="container">
            <div class="bg-white mb-3 p-3 primary-box-shadow">
                <div class="w-100 pt-2"><!-- Start: đầu chỉ mục -->
                    <div class="w-100">
                        <div class="row g-0 d-flex justify-content-start justify-content-md-around g-2">
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2" v-for="(listWebContentsCdcm,index) in listWebContentsCdcms" v-bind:key="listWebContentsCdcm._id">
                                <div class="h-100"><nuxt-link-locale class="a-decoration-none" :to="'/ho-tro/chi-tiet/'+listWebContentsCdcm.slug">
                                        <div class="d-flex flex-column justify-content-center align-items-center poiter w-100 h-100 ho-tro-box"><!-- Start: logo -->
                                            <div class="d-flex justify-content-center justify-content-xxl-center align-items-xxl-center item-icon"><!-- Start:  id:jMtcbx1a5ZB3p2pnFUi3aa-debug-component-ldr --><img class="jMtcbx1a5ZB3p2pnFUi3aa-preview-css-ldr img-fluid w-100" :src="listWebContentsCdcm.thumbnail" :alt="listWebContentsCdcm.title"><!-- End:  id:jMtcbx1a5ZB3p2pnFUi3aa-debug-component-ldr --></div><!-- End: logo --><!-- Start: name -->
                                            <div class="d-flex justify-content-center align-content-center flex-wrap w-100 ho-tro-item-label mt-1" style="text-align: center;">
                                                <p class="mb-0 py-1 w-100">{{listWebContentsCdcm.title}}</p>
                                            </div><!-- End: name -->
                                        </div>
                                    </nuxt-link-locale></div>
                            </div>
                        </div>
                    </div><!-- End: đầu chỉ mục -->
                </div>
            </div><!-- Start: thông tin hỗ trợ -->
            <div class="bg-white p-3 mb-3 primary-box-shadow"><!-- Start: title -->
                <div>
                    <h4>Câu hỏi thường gặp</h4>
                </div><!-- End: title -->
                <div class="row g-0 w-100">
                    <div class="col-12 col-md-6" v-for="(webContentsChtg,index) in webContentsChtgs" v-bind:key="webContentsChtg._id"><!-- Start: item-question -->
                        <div class="py-1 h-100"><nuxt-link-locale class="a-decoration-none" :to="'/ho-tro/chi-tiet/'+webContentsChtg.slug">
                                <div class="d-flex">
                                    <div><span class="web-content-item-span">-&nbsp;</span></div><span class="web-content-item-span">{{webContentsChtg.title}}</span>
                                </div>
                            </nuxt-link-locale></div><!-- End: item-question -->
                    </div>
                </div>
            </div><!-- End: thông tin hỗ trợ --><!-- Start: Cau hoi thuong gap -->
            <div class="bg-white p-3 mb-3 primary-box-shadow"><!-- Start: title -->
                <div>
                    <h4>Thông tin hỗ trợ</h4>
                </div><!-- End: title -->
                <div class="row g-0 w-100">
                    <div class="col-6 col-md-4" v-for="(webContentsTtht,index) in webContentsTthts" v-bind:key="webContentsTtht._id"><!-- Start: item-question -->
                        <div class="py-1 h-100"><nuxt-link-locale class="a-decoration-none" :to="'/ho-tro/chi-tiet/'+webContentsTtht.slug">
                                <div class="d-flex">
                                    <div><span class="web-content-item-span">-&nbsp;</span></div><span class="web-content-item-span">{{webContentsTtht.title}}</span>
                                </div>
                            </nuxt-link-locale></div><!-- End: item-question -->
                    </div>
                </div>
            </div><!-- End: Cau hoi thuong gap -->
        </div>
    </section>
</template><script setup>
    import { computed,watch } from 'vue';












    //replaceMome





    const $device = useDevice();
    const { isMobile,isDesktop } = useDevice();
    const route = useRoute();


    definePageMeta({
        layout: "default",

    });














    //   variables
    if(process.env.NODE_ENV==='development'){

    }









    // computed


    //attributesCal 0




        // computed





        const clearTypeName = (api)=>{
            const funF = (obj)=>{
                if(obj){
                    console.log('obj')
                    Object.keys(obj).forEach((key)=>{
                        if(key==="__typename"){
                            delete obj.__typename;
                        } else if(Array.isArray(obj[key])){
                            obj[key].forEach((item)=>{
                                if(item)
                                    funF(item);
                            });
                        } else if(typeof (obj[key]) ==="object"&&(obj[key])){
                            if(obj[key])
                                funF(obj[key]);
                        }
                    });}
            };
            funF(api);
            return api;
        };

// mutation












        //0 setup


        let listGroupWebContents= ref([]);
let listWebContentsCdcms= ref([]);
let webContentsChtgs= ref([]);
let webContentsTthts= ref([]);


let variablelistGroupWebContents={};

const resultlistGroupWebContents = await useAsyncQuery(gql` query
 groupWebContents($query: groupWebContentFindInput,$limit:Float,$skip:Float,$sort:JSONObject){
     listGroupWebContents:  groupWebContents(query:$query,limit:$limit,skip:$skip,sort:$sort)
     {
                _id label slug
        }

}`,variablelistGroupWebContents);
if(resultlistGroupWebContents.data.value&&resultlistGroupWebContents.data.value.listGroupWebContents){
listGroupWebContents.value = resultlistGroupWebContents.data.value.listGroupWebContents}

let variablelistWebContentsCdcms={sort :{orderNumber:1}, query :{groupWebContent:{eq:"Các đầu chỉ mục"},}};

const resultlistWebContentsCdcms = await useAsyncQuery(gql` query
 webContentss($query: webContentsFindInput,$limit:Float,$skip:Float,$sort:JSONObject){
     listWebContentsCdcms:  webContentss(query:$query,limit:$limit,skip:$skip,sort:$sort)
     {
                _id title keyword thumbnail description slug groupWebContent orderNumber
        }

}`,variablelistWebContentsCdcms);
if(resultlistWebContentsCdcms.data.value&&resultlistWebContentsCdcms.data.value.listWebContentsCdcms){
listWebContentsCdcms.value = resultlistWebContentsCdcms.data.value.listWebContentsCdcms}

let variablewebContentsChtgs={sort :{orderNumber:1}, query :{groupWebContent:{eq:"Câu hỏi thường gặp"},}};

const resultwebContentsChtgs = await useAsyncQuery(gql` query
 webContentss($query: webContentsFindInput,$limit:Float,$skip:Float,$sort:JSONObject){
     webContentsChtgs:  webContentss(query:$query,limit:$limit,skip:$skip,sort:$sort)
     {
                _id title slug groupWebContent orderNumber
        }

}`,variablewebContentsChtgs);
if(resultwebContentsChtgs.data.value&&resultwebContentsChtgs.data.value.webContentsChtgs){
webContentsChtgs.value = resultwebContentsChtgs.data.value.webContentsChtgs}

let variablewebContentsTthts={sort :{orderNumber:1}, query :{groupWebContent:{eq:"Thông tin hỗ trợ"},}};

const resultwebContentsTthts = await useAsyncQuery(gql` query
 webContentss($query: webContentsFindInput,$limit:Float,$skip:Float,$sort:JSONObject){
     webContentsTthts:  webContentss(query:$query,limit:$limit,skip:$skip,sort:$sort)
     {
                _id title slug groupWebContent orderNumber
        }

}`,variablewebContentsTthts);
if(resultwebContentsTthts.data.value&&resultwebContentsTthts.data.value.webContentsTthts){
webContentsTthts.value = resultwebContentsTthts.data.value.webContentsTthts}








        //0 afterData











        const methods=()=>{

        }







  // watch















    //meta


        const meta = [  {name: "theme-color" ,content:"#fff"}];
        let title = '';

    title =''





   const bodyAttrs ={};
    const  htmlAttrs={};




        useHead({
            title: title,
            viewport: 'width=device-width, initial-scale=1, maximum-scale=1',
            charset: 'utf-8',
            meta: meta,
            htmlAttrs:htmlAttrs,
            bodyAttrs:bodyAttrs,
            script: [

            ],

            link:[







            ]

        })



</script>


<!--false-->
<script>



    export default {
        name: "ho-tro-",



        data(){
            return {

                }
            },
                methods:{

                runAnimation(name,delay=0,loop=false,reverse=false){


                }



            }

        }
</script>

//update in Thu Jul 18 2024 09:12:05 GMT+0700 (Indochina Time) by loidirieng
